import KaiserSignupPage from './KaiserSignupPage';

export default KaiserSignupPage;
